import { IScene } from '@/scene/types'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton, styled, Tab as MuiTab, TabProps, Tooltip, Typography } from '@mui/material'
import clsx from 'clsx'
import { motion } from 'framer-motion'

const classes = {
  title: 'SceneTab-title',
  activeIndicator: 'SceneTab-activeIndicator',
  closeButton: 'SceneTab-closeButton',
}

type Props = {
  scene: IScene
  selected: boolean
  onClickDeleteBtn?: React.MouseEventHandler
} & TabProps

export default function SceneTab(props: Props) {
  const { scene, onClickDeleteBtn, className, selected, label, disableRipple, ...rest } = props
  const { title, url } = scene

  const handleClickDeleteBtn = (event: React.MouseEvent) => {
    event.stopPropagation()
    onClickDeleteBtn?.(event)
  }

  return (
    <Tooltip title={url}>
      <StyledTab
        className={clsx('SceneTab-root', className, {
          'Mui-selected': selected,
        })}
        disableRipple
        label={
          <>
            <Typography variant="body1" component="div" className={classes.title}>
              {title}
            </Typography>
            <IconButton
              size="small"
              onClick={handleClickDeleteBtn}
              component="div"
              className={classes.closeButton}
            >
              <CloseIcon sx={{ fontSize: '0.8rem', color: '#222' }} />
            </IconButton>
          </>
        }
        {...rest}
      />
    </Tooltip>
  )
}

const StyledTab = styled(MuiTab)(
  ({ theme }) => `
  color: #5f605f;
  background-color: #eeefed;
  padding: 10px 16px 8px 12px;
  margin: 0px 2px 0 0px;
  border: 1px solid rgb(224, 228, 238);
  border-radius: 0;
  overflow: hidden;

&:hover {
  color: ${theme.palette.primary.main}
}

&.Mui-selected {
  background-color: #fff;
  color: ${theme.palette.primary.main};
}

& .${classes.closeButton} {
  display: none;
  top: -2px;
  right: -2px;
  width: 24px;
  height: 24px;
  transform: translateY(0%);
  position: absolute;
}

&:hover .${classes.closeButton} {
  display: inline-flex;
}

& .${classes.title} {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
}


  `,
)
